export default "/images/recruit-direct-access.png?30a575ac0ced2e34eab278bb78036ae4";